import { render, staticRenderFns } from "./LandingChainBannerSlide.vue?vue&type=template&id=9a2078be&scoped=true"
import script from "./LandingChainBannerSlide.vue?vue&type=script&lang=js"
export * from "./LandingChainBannerSlide.vue?vue&type=script&lang=js"
import style0 from "./LandingChainBannerSlide.vue?vue&type=style&index=0&id=9a2078be&prod&scoped=true&lang=css"
import style1 from "./LandingChainBannerSlide.vue?vue&type=style&index=1&id=9a2078be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2078be",
  null
  
)

export default component.exports